import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import CountrySelect from "./CountrySelect";

function ProfileAddressForm({ formData, setFormData, saving }) {
    const handleChange = useCallback((event) => {
        const { id, value } = event.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    }, [setFormData]);

    return (
        <Form>
            <Form.Group className="mb-3" controlId="address">
                <Form.Label>Adres</Form.Label>
                <Form.Control 
                    type="text"
                    value={formData.address || ""}
                    onChange={handleChange}
                    disabled={saving}
                />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="postalCode">
                <Form.Label>Postcode</Form.Label>
                <Form.Control 
                    type="text"
                    value={formData.postalCode || ""}
                    onChange={handleChange}
                    disabled={saving}
                />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="city">
                <Form.Label>Stad</Form.Label>
                <Form.Control 
                    type="text"
                    value={formData.city || ""}
                    onChange={handleChange}
                    disabled={saving}
                />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="country">
                <Form.Label>Land</Form.Label>
                <CountrySelect
                    id="country"
                    value={formData.country || ""}
                    onChange={handleChange}
                    disabled={saving}
                />
            </Form.Group>
        </Form>
    );
}

ProfileAddressForm.propTypes = {
    formData: PropTypes.shape({
        address: PropTypes.string,
        postalCode: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    setFormData: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired
};

export default React.memo(ProfileAddressForm);
